<template>
  <div class="min-h-screen flex items-center justify-center bg-blue-500">
    <div
      class="bg-white p-10 rounded-xl shadow-2xl w-full max-w-md text-center"
    >
      <h1 class="text-4xl font-black text-orange-600 mb-6">🦒 Inscription</h1>

      <form class="space-y-4" @submit.prevent="handleRegister">
        <!-- NOUVEAU CHAMP : Nom (Requis par Rails schema.rb) -->
        <input
          v-model="name"
          type="text"
          placeholder="Nom d'utilisateur"
          required
          class="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 outline-none"
        />
        <input
          v-model="email"
          type="email"
          placeholder="Email"
          required
          class="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 outline-none"
        />
        <input
          v-model="password"
          type="password"
          placeholder="Mot de passe (6 car. min)"
          required
          class="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 outline-none"
        />
        <input
          v-model="password_confirmation"
          type="password"
          placeholder="Confirmer le mot de passe"
          required
          class="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 outline-none"
        />

        <p v-if="error" class="text-red-500 text-sm font-bold">
          {{ error }}
        </p>

        <button
          type="submit"
          :disabled="isLoading"
          class="w-full bg-orange-600 text-white font-bold py-3 rounded-lg hover:bg-orange-700 transition disabled:opacity-50"
        >
          {{ isLoading ? 'Création...' : "S'inscrire" }}
        </button>
      </form>

      <div class="mt-6">
        <router-link
          to="/login"
          class="text-sm text-blue-600 hover:underline font-medium"
        >
          Déjà un compte ? Se connecter
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/apiClient'

export default {
  name: 'RegisterView',
  data() {
    return {
      name: '', // Ajouté dans le state de données
      email: '',
      password: '',
      password_confirmation: '',
      error: null,
      isLoading: false
    }
  },
  methods: {
    async handleRegister() {
      if (this.password !== this.password_confirmation) {
        this.error = 'Les mots de passe ne correspondent pas.'
        return
      }

      this.isLoading = true
      this.error = null
      try {
        await apiClient.post('/api/v1/signup', {
          user: {
            name: this.name, // Ajouté dans l'envoi de la requête API
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation
          }
        })
        alert('Compte créé ! Connectez-vous.')
        this.$router.push('/login')
      } catch (err) {
        this.error = "Erreur d'inscription (Email déjà pris ?)"
        console.error(err)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
